import React from 'react';

import {LanguageMenuModuleProps} from "../models/language-menu-module.props";
import {LanguageMenuModuleController} from "../language-menu-module.controller";
import {Compose, ComposeSettings} from "../../../core/components/composers/compose";
import {LanguageMenuModuleHeader} from "./header/language-menu-module.header";
import {LanguageMenuModuleContent} from "./language-menu-module.content";
import classNames from "classnames";
import styles from "../styles/language-menu.module.scss";
import {LanguageMenuModuleBackgroundBlocker} from "./language-menu-module.background-blocker";

export class LanguageMenuModuleComponentProps extends LanguageMenuModuleProps {}

export const LanguageMenuModuleComponent = (({controller}) => {
  const {state, device} = controller;
  const {menuModel} = state;
  const {isSmallView} = device;

  return (
    <div className={classNames(styles.container, {[styles.small_view]: isSmallView}, menuModel.className)}>
      <LanguageMenuModuleBackgroundBlocker controller={controller}/>
      <LanguageMenuModuleHeader controller={controller}/>
      <LanguageMenuModuleContent controller={controller}/>
    </div>
  )
});

const settings: ComposeSettings = {
  component: LanguageMenuModuleComponent,
  propsType: LanguageMenuModuleComponentProps,
  controllerType: LanguageMenuModuleController,

  observe: true,
  injectData: true,
  createModule: true,
};

export default Compose(settings);
